import { Box } from "@mui/material";
import { ScrollCss } from "styles/GlobalCss";
import { header, sidebar } from "styles/theme";
import { styled as muiStyled } from '@mui/material/styles';
import styled from "styled-components";

const WrapContent = muiStyled(Box)(({ headerHeight, hidePadding, showToolbar, showSidebar, theme, $systemUI, len, index }) => ({
    width: `calc(100% - ${showSidebar ? sidebar : 0}px)`,
    height: `calc(100% - ${showToolbar ? headerHeight : 0}px)`,
    padding: !hidePadding && 20,
    boxSizing: "border-box",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    rowGap: 10,
    ...ScrollCss,
    [theme.breakpoints.down('md')]: {
        width: "100%"
    }
}));

const Title = styled.div`
margin-bottom: 15px;
font-size: 20px;
text-align:center;
padding:10px;

`

const Wrap = muiStyled(Box)(({ headerHeight, showToolbar, showSidebar, theme, $systemUI, len, index }) => ({
    width: "100%",
    marginTop: showToolbar && headerHeight,
    height: "100%",
    marginLeft: showSidebar && sidebar,
    [theme.breakpoints.down('md')]: {
        marginLeft: 0
    }
}));


const WrapNav = styled.div`

`

export { Wrap, WrapContent, Title, WrapNav }